import React, { useState, useContext, useMemo, useEffect, useCallback, Suspense } from 'react';
import { Route, Routes, useNavigate, useLocation } from 'react-router-dom';
import Loader from '../components/loader/loader';

import { MenuFoldOutlined, MenuUnfoldOutlined, UserOutlined, CaretDownOutlined } from '@ant-design/icons';
import { Button, Layout, Menu, Avatar, Breadcrumb, Dropdown } from 'antd';
import { FiGrid, FiArchive, FiUsers, FiTool, FiShoppingCart, FiPackage, FiShoppingBag, FiLogOut, FiMenu, } from "react-icons/fi";
import { DatePicker } from 'antd';
import {
  FcSupport, FcContacts, FcPackage, FcSettings, FcSurvey, FcBusinessman, FcMoneyTransfer, FcCurrencyExchange, FcKindle,
  FcComboChart, FcDocument, FcMultipleDevices, FcDiploma1, FcImport, FcDisclaimer
} from "react-icons/fc";

import { DataContext } from '../init/getData';
import SessionModal from './sessionModal';
import EndSessionModal from './endSessionModal';


const { Header, Sider, Content } = Layout;




const LeftMenu = (props) => {

  const { userData, setAccess, selectedYear, selectedCompany, devData, menuTabs, menuPages } = useContext(DataContext);

  const [collapsed, setCollapsed] = useState(false);
  const [openKeys, setOpenKeys] = useState([]);
  const [breadcrumbItems, setBreadcrumbItems] = useState(false);
  const [showSessionModal, setShowSessionModal] = useState(false);
  const [showEndSessionModal, setShowEndSessionModal] = useState(false);
  const navigate = useNavigate();

  const userRole = userData?.role;
  const userId = userData?.id;
  const isWebApp = devData.isWebApp;

  // Lazy-loaded components
  const SalesDashboardLazy = isWebApp
    ? React.lazy(() => import('../dashboardTab/salesDashboard/salesDashboard'))
    : require('../dashboardTab/salesDashboard/salesDashboard').default;


  const DailyEntryLazy = isWebApp
    ? React.lazy(() => import('../dailyEntry/dailyEntry'))
    : require('../dailyEntry/dailyEntry').default;


  // Accounts
  const ChartTabLazy = isWebApp
    ? React.lazy(() => import('../accountTab/chart/chartTabs'))
    : require('../accountTab/chart/chartTabs').default;

  const AuxAccountLazy = isWebApp
    ? React.lazy(() => import('../accountTab/auxAccount/auxAccount'))
    : require('../accountTab/auxAccount/auxAccount').default;

  const GroupAccountLazy = isWebApp
    ? React.lazy(() => import('../accountTab/group/group'))
    : require('../accountTab/group/group').default;

  const DeliveryLazy = isWebApp
    ? React.lazy(() => import('../accountTab/delivery/delivery'))
    : require('../accountTab/delivery/delivery').default;



  // Cash
  const ReceiptsLazy = isWebApp
    ? React.lazy(() => import('../cashControlTab/receipts/receipts'))
    : require('../cashControlTab/receipts/receipts').default;

  const PaymentLazy = isWebApp
    ? React.lazy(() => import('../cashControlTab/payments/payments'))
    : require('../cashControlTab/payments/payments').default;

  const CashAccountLazy = isWebApp
    ? React.lazy(() => import('../cashControlTab/cashAccount/cashAccount'))
    : require('../cashControlTab/cashAccount/cashAccount').default;

  const VarianceAccountLazy = isWebApp
    ? React.lazy(() => import('../cashControlTab/varianceAccount/varianceAccount'))
    : require('../cashControlTab/varianceAccount/varianceAccount').default;

  const CashTransferLazy = isWebApp
    ? React.lazy(() => import('../cashControlTab/cashTransfer/cashTransfer'))
    : require('../cashControlTab/cashTransfer/cashTransfer').default;



  // HR Payroll
  const EmployeeLazy = isWebApp
    ? React.lazy(() => import('../hrTab/employee/employee'))
    : require('../hrTab/employee/employee').default;

  const SalaryLazy = isWebApp
    ? React.lazy(() => import('../hrTab/salary/salary'))
    : require('../hrTab/salary/salary').default;



  // Purchase
  const PurchaseInvoiceLazy = isWebApp
    ? React.lazy(() => import('../purchaseTab/purchaseInvoice/purchaseInvoice'))
    : require('../purchaseTab/purchaseInvoice/purchaseInvoice').default;

  const SupplierLazy = isWebApp
    ? React.lazy(() => import('../purchaseTab/supplier/supplier'))
    : require('../purchaseTab/supplier/supplier').default;

  // Sale
  const CustomerLazy = isWebApp
    ? React.lazy(() => import('../salesTab/customer/customer'))
    : require('../salesTab/customer/customer').default;

  const SaleInvoiceLazy = isWebApp
    ? React.lazy(() => import('../salesTab/salesInvoice/salesInvoice'))
    : require('../salesTab/salesInvoice/salesInvoice').default;

  // Expenses
  const ExpenseAccountLazy = isWebApp
    ? React.lazy(() => import('../expensesTab/expenseAccount/expenseAccount'))
    : require('../expensesTab/expenseAccount/expenseAccount').default;

  const ExpenseSupplierLazy = isWebApp
    ? React.lazy(() => import('../expensesTab/expenseSupplier/expenseSupplier'))
    : require('../expensesTab/expenseSupplier/expenseSupplier').default;

  const ExpenseInvoiceLazy = isWebApp
    ? React.lazy(() => import('../expensesTab/expenseInvoice/expenseInvoice'))
    : require('../expensesTab/expenseInvoice/expenseInvoice').default;

  // Inventory
  const ProductLazy = isWebApp
    ? React.lazy(() => import('../inventoryTab/product/product'))
    : require('../inventoryTab/product/product').default;

  const CategoryLazy = isWebApp
    ? React.lazy(() => import('../inventoryTab/category/category'))
    : require('../inventoryTab/category/category').default;

  const BrandLazy = isWebApp
    ? React.lazy(() => import('../inventoryTab/brand/brand'))
    : require('../inventoryTab/brand/brand').default;

  const SeasonLazy = isWebApp
    ? React.lazy(() => import('../inventoryTab/season/season'))
    : require('../inventoryTab/season/season').default;

  const VatGroupLazy = isWebApp
    ? React.lazy(() => import('../inventoryTab/vatGroup/vatGroup'))
    : require('../inventoryTab/vatGroup/vatGroup').default;

  // Report
  const FinancialReportsLazy = isWebApp
    ? React.lazy(() => import('../reportTab/financialReports/financialReports'))
    : require('../reportTab/financialReports/financialReports').default;

  const OperationalReportsLazy = isWebApp
    ? React.lazy(() => import('../reportTab/operationalReports/operationalReports'))
    : require('../reportTab/operationalReports/operationalReports').default;

  const SessionLazy = isWebApp
    ? React.lazy(() => import('../reportTab/sessionLog/logReports'))
    : require('../reportTab/sessionLog/logReports').default;

  const StockReportsLazy = isWebApp
    ? React.lazy(() => import('../reportTab/stockReports/stockReports'))
    : require('../reportTab/stockReports/stockReports').default;

  const ValidationReportsLazy = isWebApp
    ? React.lazy(() => import('../reportTab/validationReports/validationReports'))
    : require('../reportTab/validationReports/validationReports').default;

  // Stock
  const StockControlLazy = isWebApp
    ? React.lazy(() => import('../stockTab/stockControl/stockControl'))
    : require('../stockTab/stockControl/stockControl').default;

  const StockTransferLazy = isWebApp
    ? React.lazy(() => import('../stockTab/stockTransfer/stockTransfer'))
    : require('../stockTab/stockTransfer/stockTransfer').default;

  const StockCountLazy = isWebApp
    ? React.lazy(() => import('../stockTab/stockCount/stockCount'))
    : require('../stockTab/stockCount/stockCount').default;

  // Tools
  const StockToolsLazy = isWebApp
    ? React.lazy(() => import('../toolsTab/stockTools/stockTools'))
    : require('../toolsTab/stockTools/stockTools').default;

  const OpeningYearLazy = isWebApp
    ? React.lazy(() => import('../toolsTab/openingYear/openingYear'))
    : require('../toolsTab/openingYear/openingYear').default;

  const PosToolsLazy = isWebApp
    ? React.lazy(() => import('../toolsTab/pos/pos'))
    : require('../toolsTab/pos/pos').default;

  const ImportToolsLazy = isWebApp
    ? React.lazy(() => import('../toolsTab/import/importTools'))
    : require('../toolsTab/import/importTools').default;

  // Dev Tab
  const BranchLazy = isWebApp
    ? React.lazy(() => import('../devTab/branch/branch'))
    : require('../devTab/branch/branch').default;

  const CompanyLazy = isWebApp
    ? React.lazy(() => import('../devTab/company/company'))
    : require('../devTab/company/company').default;

  const YearLazy = isWebApp
    ? React.lazy(() => import('../devTab/year/year'))
    : require('../devTab/year/year').default;

  const AppModeLazy = isWebApp
    ? React.lazy(() => import('../devTab/appMode/appMode'))
    : require('../devTab/appMode/appMode').default;

  const WarehouseLazy = isWebApp
    ? React.lazy(() => import('../devTab/warehouse/warehouse'))
    : require('../devTab/warehouse/warehouse').default;

  const DevGeneralLazy = isWebApp
    ? React.lazy(() => import('../devTab/devGeneral/devGeneral'))
    : require('../devTab/devGeneral/devGeneral').default;

  const YearClosingLazy = isWebApp
  ? React.lazy(() => import('../devTab/yearClosing/yearClosing'))
  : require('../devTab/yearClosing/yearClosing').default;

    const StockClosingLazy = isWebApp
  ? React.lazy(() => import('../devTab/stockClosing/stockClosing'))
  : require('../devTab/stockClosing/stockClosing').default;

  // Settings
  const GeneralLazy = isWebApp
    ? React.lazy(() => import('../settingTab/general/general'))
    : require('../settingTab/general/general').default;

  const LinkAccountLazy = isWebApp
    ? React.lazy(() => import('../settingTab/linkAccount/linkAccount'))
    : require('../settingTab/linkAccount/linkAccount').default;

  const UserLazy = isWebApp
    ? React.lazy(() => import('../settingTab/user/user'))
    : require('../settingTab/user/user').default;

  const RoleLazy = isWebApp
    ? React.lazy(() => import('../settingTab/role/role'))
    : require('../settingTab/role/role').default;

  const CurrencyLazy = isWebApp
    ? React.lazy(() => import('../settingTab/currency/currency'))
    : require('../settingTab/currency/currency').default;

  // Retail
  const PosLazy = isWebApp
    ? React.lazy(() => import('../retailTab/pos/pos'))
    : require('../retailTab/pos/pos').default;

  const DineInLazy = isWebApp
    ? React.lazy(() => import('../retailTab/dineIn/dineIn'))
    : require('../retailTab/dineIn/dineIn').default;

  const items = useMemo(() => [
    userRole.dashboardTab && {
      key: menuTabs.dashboard,
      label: menuTabs.dashboard,
      icon: <FcComboChart size={22} />,
      children: [
        userRole.salesDashboardPage && {
          key: menuPages.salesDashboard,
          label: menuPages.salesDashboard,
        },
      ]

    },
    userRole.dailyEntryTab && {
      key: menuTabs.dailyEntry,
      label: menuTabs.dailyEntry,
      icon: <FcDiploma1 size={22} />,
    },
    userRole.accountTab && {
      key: 'Accounts',
      label: menuTabs.accounts,
      icon: <FcContacts size={22} />,
      children: [
        userRole.chartOfAccountPage && {
          key: menuPages.chartOfAccount,
          label: menuPages.chartOfAccount,
        },
        userRole.myAccountsPage && {
          key: menuPages.myAccounts,
          label: menuPages.myAccounts,
        },
        userRole.groupsPage && {
          key: menuPages.groups,
          label: menuPages.groups,
        },
        userRole.deliveryPage && {
          key: menuPages.delivery,
          label: menuPages.delivery,
        },
      ]
    },
    userRole.cashTab && {
      key: menuTabs.cashControl,
      label: menuTabs.cashControl,
      icon: <FcMoneyTransfer size={21} />,
      children: [
        userRole.cashAccountPage && {
          key: menuPages.cashAccount,
          label: menuPages.cashAccount,
        },
        userRole.varianceAccountPage && {
          key: menuPages.varianceAccount,
          label: menuPages.varianceAccount,
        },
        userRole.cashTransferPage && {
          key: menuPages.cashTransfer,
          label: menuPages.cashTransfer,
        },
        userRole.paymentsPage && {
          key: menuPages.payments,
          label: menuPages.payments,
        },
        userRole.receiptsPage && {
          key: menuPages.receipts,
          label: menuPages.receipts,
        },
      ]
    },
    userRole.hrTab && {
      key: menuTabs.hrPayroll,
      label: menuTabs.hrPayroll,
      icon: <FcBusinessman size={22} />,
      children: [
        userRole.employeePage && {
          key: menuPages.employee,
          label: menuPages.employee,
        },
        userRole.salaryPage && {
          key: menuPages.salary,
          label: menuPages.salary,
        },
      ]
    },
    userRole.purchaseTab && {
      key: menuTabs.purchases,
      icon: <FcDocument size={22} />,
      label: menuTabs.purchases,
      children: [
        userRole.supplierPage && {
          key: menuPages.supplier,
          label: menuPages.supplier,
        },
        userRole.purchaseInvoicePage && {
          key: menuPages.purchaseInvoice,
          label: menuPages.purchaseInvoice,
        },
        userRole.purchaseReturnPage && {
          key: menuPages.purchaseReturn,
          label: menuPages.purchaseReturn,
        },
        userRole.purchaseOrderPage && {
          key: menuPages.purchaseOrder,
          label: menuPages.purchaseOrder,
        },
      ]
    },
    userRole.salesTab && {
      key: menuTabs.sales,
      label: menuTabs.sales,
      icon: <FiShoppingCart strokeWidth={2.5} color={'red'} size={20} />,
      children: [
        userRole.customerPage && {
          key: menuPages.customer,
          label: menuPages.customer,
        },
        userRole.salesInvoicePage && {
          key: menuPages.salesInvoice,
          label: menuPages.salesInvoice,
        },
        userRole.salesReturnPage && {
          key: menuPages.salesReturn,
          label: menuPages.salesReturn,
        },
        userRole.salesOrderPage && {
          key: menuPages.salesOrder,
          label: menuPages.salesOrder,
        },
      ]
    },
    userRole.expenseTab && {
      key: menuTabs.expenses,
      label: menuTabs.expenses,
      icon: <FcKindle size={20} />,
      children: [
        userRole.expenseAccountPage && {
          key: menuPages.expenseAccount,
          label: menuPages.expenseAccount,
        },
        userRole.expenseSupplierPage && {
          key: menuPages.expenseSupplier,
          label: menuPages.expenseSupplier,
        },
        userRole.expenseInvoicePage && {
          key: menuPages.expenseInvoice,
          label: menuPages.expenseInvoice,
        },
      ]
    },
    userRole.stockTab && {
      key: menuTabs.stock,
      label: menuTabs.stock,
      icon: <FcPackage size={22} />,
      children: [
        userRole.stockControlPage && {
          key: menuPages.stockControl,
          label: menuPages.stockControl,
        },
        userRole.stockTransferPage && {
          key: menuPages.stockTransfer,
          label: menuPages.stockTransfer,
        },
        userRole.stockCountPage && {
          key: menuPages.stockCount,
          label: menuPages.stockCount,
        },
      ]
    },
    userRole.inventoryTab && {
      key: menuTabs.inventory,
      label: menuTabs.inventory,
      icon: <FiPackage strokeWidth={2.5} color={'green'} size={20} />,
      children: [
        userRole.productsPage && {
          key: menuPages.products,
          label: menuPages.products,
        },
        userRole.categoriesPage && {
          key: menuPages.categories,
          label: menuPages.categories,
        },
        userRole.brandsPage && {
          key: menuPages.brands,
          label: menuPages.brands,
        },
        userRole.seasonsPage && {
          key: menuPages.seasons,
          label: menuPages.seasons,
        },
        userRole.vatGroupPage && {
          key: menuPages.vatGroup,
          label: menuPages.vatGroup,
        },
      ]
    },
    userRole.reportTab && {
      key: menuTabs.reports,
      label: menuTabs.reports,
      icon: <FcSurvey size={22} />,
      children: [
        userRole.financialPage && {
          key: menuPages.financial,
          label: menuPages.financial,
        },
        userRole.operationalPage && {
          key: menuPages.operational,
          label: menuPages.operational,
        },
        userRole.stockReportPage && {
          key: menuPages.stockReport,
          label: menuPages.stockReport,
        },
        userRole.sessionsPage && {
          key: menuPages.sessions,
          label: menuPages.sessions,
        },
        userRole.sessionsPage && {
          key: menuPages.validation,
          label: menuPages.validation,
        }
      ]

    },

    userRole.toolTab && {
      key: menuTabs.tools,
      label: menuTabs.tools,
      icon: <FcSupport size={22} />,
      children: [
        userRole.stockToolsPage && {
          key: menuPages.stockTools,
          label: menuPages.stockTools,
        },
        userRole.openingYearPage && {
          key: menuPages.openingYear,
          label: menuPages.openingYear,
        },
        userRole.posToolsPage && {
          key: menuPages.posTools,
          label: menuPages.posTools,
        },
        userRole.importPage && {
          key: menuPages.import,
          label: menuPages.import,
        },
        userRole.backupPage && {
          key: menuPages.backup,
          label: menuPages.backup,
        },
      ]

    },
    userRole.settingTab && {
      key: menuTabs.settings,
      label: menuTabs.settings,
      icon: <FcSettings size={22} />,
      children: [
        userRole.generalPage && {
          key: menuPages.general,
          label: menuPages.general,
        },
        userRole.userPage && {
          key: menuPages.user,
          label: menuPages.user,
        },
        userRole.rolePage && {
          key: menuPages.role,
          label: menuPages.role,
        },
        userRole.linkAccountPage && {
          key: menuPages.linkAccount,
          label: menuPages.linkAccount,
        },
        userRole.currencyPage && {
          key: menuPages.currency,
          label: menuPages.currency,
        },
      ]
    },
    userId === 777 && {
      key: 'DevSettings',
      label: 'DevSettings',
      icon: <FcSettings size={22} />,
      children: [
        { key: 'Year', label: 'Year' },
        { key: 'Company', label: 'Company' },
        { key: 'Branch', label: 'Branch' },
        { key: 'Warehouse', label: 'Warehouse' },
        { key: 'AppMode', label: 'AppMode' },
        { key: 'DevGeneral', label: 'DevGeneral' },
        { key: 'YearClosing', label: 'Year Closing' }, 
   
      ],
    },
    {
      type: 'divider',
    },
    userRole.retailTab && {
      key: menuTabs.retail,
      label: menuTabs.retail,
      icon: <FcMultipleDevices size={22} />,
      children: [
        userRole.posPage && {
          key: menuPages.pos,
          label: menuPages.pos,
        },
        userRole.dineInPage && {
          key: menuPages.dineIn,
          label: menuPages.dineIn,
        },
      ]

    },
  ], []);

  const userMenu = useMemo(() => [
    {
      label: 'View Profile',
      key: '0',
      icon: <FcBusinessman size={20} />,
    },
    userId !== 777 && {
      label: 'View Session',
      key: '1',
      icon: <FcDocument size={19} />,
      onClick: () => setShowSessionModal(!showSessionModal),
    },
    userId !== 777 && {
      label: 'End Session',
      key: '2',
      icon: <FcDisclaimer size={20} />,
      onClick: () => setShowEndSessionModal(!showEndSessionModal),
    },
    {
      type: 'divider',
    },
    {
      label: 'LogOut',
      key: '3',
      icon: <FcImport size={20} />,
      onClick: () => logOut(),
    },
  ], []);

  const logOut = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('userName');
    setAccess(false);
  }


  const handleMenuClick = useCallback(({ key, keyPath }) => {
    navigate(`/${key}`);
    const title = keyPath.at(-1);
    const newBreadcrumbItems = keyPath.length === 1 ? [{ title: 'Home' }, { title }] : [{ title }, { title: key }];
    if (JSON.stringify(newBreadcrumbItems) !== JSON.stringify(breadcrumbItems)) {
      setBreadcrumbItems(newBreadcrumbItems);
    }
  }, [navigate, breadcrumbItems]);


  const onOpenChange = useCallback((keys) => {
    const latestOpenKey = keys.find((key) => !openKeys.includes(key));
    setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
  }, [openKeys]);






  return (
    <Layout style={{ userSelect: 'none' }}>
      <Sider trigger={null} collapsible collapsed={collapsed}>
        <Menu
          theme="light"
          mode="inline"
          defaultSelectedKeys={['1']}
          items={items}
          onClick={handleMenuClick}
          onOpenChange={onOpenChange}
          openKeys={openKeys}
          style={{ height: '100vh', overflowY: 'auto', userSelect: 'none' }}
          className="custom-scrollbar"
        />
      </Sider>
      <Layout>
        <Header style={{ padding: 0, background: '#fefefe', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Button
              type="text"
              icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
              onClick={() => setCollapsed(!collapsed)}
              style={{ fontSize: '16px', width: 64, height: 64 }}
            />
            <Breadcrumb
              style={{ margin: '0 16px' }}
              items={breadcrumbItems}
            />
          </div>
          <div style={{ display: 'flex', alignItems: 'center', marginRight: '1%', justifyContent: 'space-between', gap: '40px', }}>
          <span
            style={{
              maxWidth: '90%',
              whiteSpace: 'normal',
              lineHeight: '1.2',
            }}
          >
            <span style={{ whiteSpace: 'nowrap' }}>
              {selectedCompany?.name}
            </span>
            .{selectedYear?.year}
          </span>

            <Dropdown menu={{ items: userMenu }} trigger={['click']} >
              <div
                style={{
                  marginRight: '2%',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  cursor: 'pointer',
                }}
              >
                <Avatar size="small" icon={<UserOutlined />} />
                <span>{userData.name}</span>
                <CaretDownOutlined />
              </div>
            </Dropdown>
          </div>
        </Header>

        <Content
          style={{
            paddingTop: 10,
            paddingLeft: 10,
            paddingRight: 10,
            background: '#f9fafa',
            borderRadius: 8,
            overflowY: 'auto',
            maxHeight: '90vh'
          }}
        >
          <Routes>
            {/* Dashboard */}
            <Route path={menuPages.salesDashboard} element={<React.Suspense fallback={<Loader />}><SalesDashboardLazy /></React.Suspense>} key="SalesDashboardLazy" />

            {/* DailyEntry */}
            <Route path={menuTabs.dailyEntry} element={<React.Suspense fallback={<Loader />}><DailyEntryLazy /></React.Suspense>} />

            {/* Accounts */}
            <Route path={menuPages.chartOfAccount} element={<React.Suspense fallback={<Loader />}><ChartTabLazy /></React.Suspense>} />
            <Route path={menuPages.myAccounts} element={<React.Suspense fallback={<Loader />}><AuxAccountLazy /></React.Suspense>} />
            <Route path={menuPages.groups} element={<React.Suspense fallback={<Loader />}><GroupAccountLazy /></React.Suspense>} />
            <Route path={menuPages.delivery} element={<React.Suspense fallback={<Loader />}><DeliveryLazy /></React.Suspense>} />

            {/* Cash */}
            <Route path={menuPages.receipts} element={<React.Suspense fallback={<Loader />}><ReceiptsLazy /></React.Suspense>} />
            <Route path={menuPages.payments} element={<React.Suspense fallback={<Loader />}><PaymentLazy /></React.Suspense>} />
            <Route path={menuPages.cashAccount} element={<React.Suspense fallback={<Loader />}><CashAccountLazy /></React.Suspense>} />
            <Route path={menuPages.varianceAccount} element={<React.Suspense fallback={<Loader />}><VarianceAccountLazy /></React.Suspense>} />
            <Route path={menuPages.cashTransfer} element={<React.Suspense fallback={<Loader />}><CashTransferLazy /></React.Suspense>} />

            {/* HR Payroll */}
            <Route path={menuPages.employee} element={<React.Suspense fallback={<Loader />}><EmployeeLazy /></React.Suspense>} />
            <Route path={menuPages.salary} element={<React.Suspense fallback={<Loader />}><SalaryLazy /></React.Suspense>} />

            {/* Purchase */}
            <Route path={menuPages.supplier} element={<React.Suspense fallback={<Loader />}><SupplierLazy /></React.Suspense>} />
            <Route path={menuPages.purchaseInvoice} element={<React.Suspense fallback={<Loader />}><PurchaseInvoiceLazy type={'PurchaseInvoice'} isDebit={true} isOrder={false} /></React.Suspense>} />
            <Route path={menuPages.purchaseReturn} element={<React.Suspense fallback={<Loader />}><PurchaseInvoiceLazy type={'PurchaseReturn'} isDebit={false} isOrder={false} /></React.Suspense>} />
            <Route path={menuPages.purchaseOrder} element={<React.Suspense fallback={<Loader />}><PurchaseInvoiceLazy type={'PurchaseOrder'} isDebit={true} isOrder={true} /></React.Suspense>} />

            {/* Sales */}
            <Route path={menuPages.customer} element={<React.Suspense fallback={<Loader />}><CustomerLazy /></React.Suspense>} />
            <Route path={menuPages.salesInvoice} element={<React.Suspense fallback={<Loader />}><SaleInvoiceLazy type={'SalesInvoice'} isDebit={false} isOrder={false} /></React.Suspense>} />
            <Route path={menuPages.salesReturn} element={<React.Suspense fallback={<Loader />}><SaleInvoiceLazy type={'SalesReturn'} isDebit={true} isOrder={false} /></React.Suspense>} />
            <Route path={menuPages.salesOrder} element={<React.Suspense fallback={<Loader />}><SaleInvoiceLazy type={'SalesOrder'} isDebit={false} isOrder={true} /></React.Suspense>} />

            {/* Expenses */}
            <Route path={menuPages.expenseAccount} element={<React.Suspense fallback={<Loader />}><ExpenseAccountLazy /></React.Suspense>} />
            <Route path={menuPages.expenseSupplier} element={<React.Suspense fallback={<Loader />}><ExpenseSupplierLazy /></React.Suspense>} />
            <Route path={menuPages.expenseInvoice} element={<React.Suspense fallback={<Loader />}><ExpenseInvoiceLazy type={'ExpenseInvoice'} isDebit={true} isOrder={false} Payment /></React.Suspense>} />

            {/* Inventory */}
            <Route path={menuPages.products} element={<React.Suspense fallback={<Loader />}><ProductLazy /></React.Suspense>} />
            <Route path={menuPages.categories} element={<React.Suspense fallback={<Loader />}><CategoryLazy /></React.Suspense>} />
            <Route path={menuPages.brands} element={<React.Suspense fallback={<Loader />}><BrandLazy /></React.Suspense>} />
            <Route path={menuPages.seasons} element={<React.Suspense fallback={<Loader />}><SeasonLazy /></React.Suspense>} />
            <Route path={menuPages.vatGroup} element={<React.Suspense fallback={<Loader />}><VatGroupLazy /></React.Suspense>} />

            {/* Reports */}
            <Route path={menuPages.financial} element={<React.Suspense fallback={<Loader />}><FinancialReportsLazy /></React.Suspense>} />
            <Route path={menuPages.operational} element={<React.Suspense fallback={<Loader />}><OperationalReportsLazy /></React.Suspense>} />
            <Route path={menuPages.sessions} element={<React.Suspense fallback={<Loader />}><SessionLazy /></React.Suspense>} />
            <Route path={menuPages.stockReport} element={<React.Suspense fallback={<Loader />}><StockReportsLazy /></React.Suspense>} />
            <Route path={menuPages.validation} element={<React.Suspense fallback={<Loader />}><ValidationReportsLazy /></React.Suspense>} />


            {/* Stock */}
            <Route path={menuPages.stockControl} element={<React.Suspense fallback={<Loader />}><StockControlLazy /></React.Suspense>} />
            <Route path={menuPages.stockTransfer} element={<React.Suspense fallback={<Loader />}><StockTransferLazy /></React.Suspense>} />
            <Route path={menuPages.stockCount} element={<React.Suspense fallback={<Loader />}><StockCountLazy /></React.Suspense>} />

            {/* Tools */}
            <Route path={menuPages.stockTools} element={<React.Suspense fallback={<Loader />}><StockToolsLazy /></React.Suspense>} />
            <Route path={menuPages.openingYear} element={<React.Suspense fallback={<Loader />}><OpeningYearLazy /></React.Suspense>} />
            <Route path={menuPages.posTools} element={<React.Suspense fallback={<Loader />}><PosToolsLazy /></React.Suspense>} />
            <Route path={menuPages.import} element={<React.Suspense fallback={<Loader />}><ImportToolsLazy /></React.Suspense>} />

            {/* Settings */}
            <Route path={menuPages.general} element={<React.Suspense fallback={<Loader />}><GeneralLazy /></React.Suspense>} />
            <Route path={menuPages.linkAccount} element={<React.Suspense fallback={<Loader />}><LinkAccountLazy /></React.Suspense>} />
            <Route path={menuPages.user} element={<React.Suspense fallback={<Loader />}><UserLazy /></React.Suspense>} />
            <Route path={menuPages.role} element={<React.Suspense fallback={<Loader />}><RoleLazy /></React.Suspense>} />
            <Route path={menuPages.currency} element={<React.Suspense fallback={<Loader />}><CurrencyLazy /></React.Suspense>} />

            {/* Retail */}
            <Route path={menuPages.pos} element={<React.Suspense fallback={<Loader />}><PosLazy /></React.Suspense>} />
            <Route path={menuPages.dineIn} element={<React.Suspense fallback={<Loader />}><DineInLazy /></React.Suspense>} />


            {/* Dev */}
            <Route path="Year" element={<React.Suspense fallback={<Loader />}><YearLazy /></React.Suspense>} />
            <Route path="Branch" element={<React.Suspense fallback={<Loader />}><BranchLazy /></React.Suspense>} />
            <Route path="Company" element={<React.Suspense fallback={<Loader />}><CompanyLazy /></React.Suspense>} />
            <Route path="AppMode" element={<React.Suspense fallback={<Loader />}><AppModeLazy /></React.Suspense>} />
            <Route path="Warehouse" element={<React.Suspense fallback={<Loader />}><WarehouseLazy /></React.Suspense>} />
            <Route path="DevGeneral" element={<React.Suspense fallback={<Loader />}><DevGeneralLazy /></React.Suspense>} />
            <Route path="YearClosing" element={<React.Suspense fallback={<Loader />}><YearClosingLazy /></React.Suspense>} />
            <Route path="StockClosing" element={<React.Suspense fallback={<Loader />}><StockClosingLazy /></React.Suspense>} />


          </Routes>


        </Content>
      </Layout>


      {userData !== 777 &&
        <>
          {showSessionModal &&
            <SessionModal
              showModal={showSessionModal}
              toggleModal={() => setShowSessionModal(!showSessionModal)}
            />
          }

          <EndSessionModal
            showModal={showEndSessionModal}
            toggleModal={() => setShowEndSessionModal(!showEndSessionModal)}
            setAccess={setAccess}
          />
        </>
      }

    </Layout>
  );
};
export default React.memo(LeftMenu);